import { Step } from "react-joyride";

const createProposalTourSteps: Step[] = [
  {
    target: ".tour-select-client",
    content: "Click here to select a Company.",
    //hideOverlay: true,
  },
  {
    target: ".tour-select-contact",
    content: "Now choose from a list of contacts available from the Company",
    //hideOverlay: true,
  },
  {
    target: ".tour-create-client-button",
    content: "If needed, you may choose to create a new client at this time.",
    //hideOverlay: true,
  },
  {
    target: ".tour-sales-tracking-fields",
    content: "Optional fields for proposal sales tracking.",
  },
  {
    target: ".tour-continue-button",
    content: "Click here to continue",
    buttons: ["back", "close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
];

export default createProposalTourSteps;
